import Modbus from "../modbus_with_scheduler.js";
import {SerialPort}	from "webserial";
import sleep  from "sleep";
import Bottleneck from "bottleneck";
import * as usbutil from "../usbutil.js";
import Device from "../device.js";


const REG_OPERATOR_LEVEL = 4287;

const REG_PHYSICAL_UNITS_BASE = 1919;

const REG_GENERAL_INFORMATION 	= 1319;

const REG_SENSOR_REF  		= 1279;
const REG_SENSOR_NAME 		= 1287;
const REG_SENSOR_LOT 		= 1295;
const REG_SENSOR_LOT_DATE 	= 1303;
const REG_SENSOR_SN 		= 1311;


const SENSOR_IDENTIFICATION = {
  "Sensor Ref": REG_SENSOR_REF,
  "Sensor name": REG_SENSOR_NAME,
  "Sensor Lot": REG_SENSOR_LOT,
  "Sensor Lot date": REG_SENSOR_LOT_DATE,
  "Sensor SN": REG_SENSOR_SN
};

/* these are RW registers */
const REG_PMC1			= 2089;
const REG_PMC6			= 2409;
const REG_PMC = [, REG_PMC1, , , , , REG_PMC6];

const REG_SMC7			= 2663;
const REG_SMC10			= 2759;
const REG_SMC13			= 2855;
const REG_SMC14			= 2887;

const REG_SMC = [, , , , , , , REG_SMC7, , , REG_SMC10, , , REG_SMC13, REG_SMC14];


/* low point calibaration register */
const REG_CP1           = 5161;

/* high point calibaration register */
const REG_CP2           = 5193;

const REG_CALIBRATION_STATUS	= 5189;
const REG_STATUS_CP1	= 5157;
const REG_STATUS_CP2	= 5189;

const CALIBRATION_STATUS = {
  0: "Ok",
  1: "Oxygen value to be calibrated at is too low",
  2: "Oxygen value to be calibrated at is too high",
  4: "current temperature reading is too low",
  8: "current temperature reading is too high",
  16: "temperature reading during calibration is not stable",
  32: "Phase is too low for the oxygen value to be calibrated at",
  64: "Phase too high for the oxygen value to be calibrated at",
  128: "Phase reading during calibration is not stable"
};

const PHYSICAL_UNITS = {
  0x00000000: "none",
  0x00000002: "K",
  0x00000004: "°C",
  0x00000008: "°F",
  0x00000010: "%-vol",
  0x00000020: "%-sat",
  0x00000040: "ug/l ppb",
  0x00000080: "mg/l ppm",
  0x00000100: "g/l",
  0x00000200: "uS/cm",
  0x00000400: "mS/cm",
  0x00000800: "1/cm",
  0x00001000: "pH",
  0x00002000: "mV/pH",
  0x00004000: "kOhm",
  0x00008000: "MOhm",
  0x00010000: "pA",
  0x00020000: "nA",
  0x00040000: "uA",
  0x00080000: "mA",
  0x00100000: "uV",
  0x00200000: "mV",
  0x00400000: "V",
  0x00800000: "mbar",
  0x01000000: "Pa",
  0x02000000: "Ohm",
  0x04000000: "%/°C",
  0x08000000: "°",
  0x10000000: "not used",
  0x20000000: "not used",
  0x40000000: "not used",
  0x80000000: "SPECIAL"
};


class MyDevice extends Device {
  constructor(serialPort_or_modbus) {
    super(serialPort_or_modbus);

    this.id = "-";
    this.value = "-";
    this.status = "-";
    this.calibrationStatus = "-";
    this.internalTemperature = "-";   

    this.physical_layer = serialPort_or_modbus;

    if (serialPort_or_modbus instanceof Modbus) {
      this.modbus = serialPort_or_modbus;
      this.__open = true;
    } else {
      /* wrap the serialPort object into Modbus if necessary */    
      this.modbus = new Modbus();
      this.modbus.wrap(serialPort_or_modbus);      
    }

    /* publicate remote methods to clients */
    //jfermi.RM_visifermdo_clearCalibration = this.RM_visifermdo_clearCalibration.bind(this);
    //jfermi.RM_visifermdo_calibrateTo0 = this.RM_visifermdo_calibrateTo0.bind(this);
    //jfermi.RM_visifermdo_calibrateTo21 = this.RM_visifermdo_calibrateTo21.bind(this);

  }
  async initialize() {
    try {
      if(!this.__open) {
        await sleep(2000);
        await this.modbus.open({
          baudRate: 19200,
          dataBits: 8,
          parity: "none",
          stopBits: 2    
        });      
      }

      this.id = (await this.getSensorIdentification())["Sensor name"];
      this.serialNumber = (await this.getSensorIdentification())["Sensor SN"];


      if (this.physical_layer instanceof SerialPort) {
        this.usbProductName = (await this.physical_layer.getInfo()).usbProductName;
        this.usbSerialNumber = (await this.physical_layer.getInfo()).usbSerialNumber;    
      } else {
        this.usbProductName = "hamilton_dencytee";
        this.usbSerialNumber = "1";         
      }

      this.name = usbutil.getDeviceName(`${this.usbProductName}_${this.usbSerialNumber}`) || "dencytee";    

      let endpoint = `${this.usbProductName}_${this.usbSerialNumber}`;

      /* publicate remote methods to clients */
      //jfermi[`RM_${endpoint}_setMLM`] = this.RM_iqflow_setMLM.bind(this);
      //jfermi[`RM_${endpoint}_wink`] = this.RM_iqflow_wink.bind(this);

      this.status = "ok";
    } catch(e) {
      this.status = "failed: " + e;
      throw e;
    }
  }
  async update() {    
    try {
      this.tcd = await this.getTCD();
      this.value = this.tcd;
      this.temperature = await this.getTemperature();

      await this.setOperatorLevel("specialist", "16021966");
      this.transmission = await this.getTransmission();
      this.reflection = await this.getReflection();
      await this.setOperatorLevel("user", "0");

      this.calibrationStatus = "";
      this.status = "ok";
    } catch(e) {
      this.value = "-";
      this.internalTemperature = "-";
      this.calibrationStatus = "-";
      this.status = `Failed: ${e}`;
      throw e;      
    }
  }
  /*
  	  default password for operator levels: 
      uid: 0x03 (user);           pwd: 0
      uid: 0x0C (administrator);  pwd: 18111978
      uid: 0x30 (specialist);     pwd: 16021966

      https://craft-sensors.s3.amazonaws.com/File-Uploads/Visiferm_ProgrammersManual_ODOUM043_62417905.pdf?mtime=20180725234949
  */  
  async setOperatorLevel(user="user", password="0") {        
    var uid = {
      "user": 0x03,
      "administrator": 0x0C,
      "specialist": 0x30
    }[user.toLowerCase()];

    var uint8Array = new Uint8Array(8);
    var dataView = new DataView(uint8Array.buffer);

    var pwd = Number(password, 10);

    /* userid */
    dataView.setUint16(0, uid);
    dataView.setUint16(2, 0);

    /* password */
    dataView.setUint32(4, pwd);       
    var holder = dataView.getUint16(4);
    dataView.setUint16(4, dataView.getUint16(6));
    dataView.setUint16(6, holder);

    /* for example: */
    /* admin password: 18111978 */
    /* password in hex: 01 14 5D EA */        
    /*
       we have to send this way: 
         dataView.setUint8(4, 0x5D);
         dataView.setUint8(5, 0xEA);
         dataView.setUint8(6, 0x01);
         dataView.setUint8(7, 0x14);    
    */

    await this.modbus.presetMultipleRegisters(0x1, REG_OPERATOR_LEVEL, uint8Array.buffer);
  }
  async getPMC1PhysicalUnit() {   
    var arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP1, 6, true);
    var dataView = new DataView(arrayBuffer);               
    var unit = dataView.getUint32(4, true);    
  }
  async getPMC1PhysicalUnitString() {
    /* first we get the physical unit id */
    var arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP1, 6, true);
    var dataView = new DataView(arrayBuffer);               
    var unit = dataView.getUint32(4, true);

    /* then we translate it to a string */
    /* the unit id is the offset        */
    arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_PHYSICAL_UNITS_BASE+unit, 4, true);
    var str = new TextDecoder().decode( new Uint8Array(arrayBuffer) );
    str = str.trim();
    return(str);
  }
  async getPMC1PhysicalUnitStringByID(unit) {
    var arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_PHYSICAL_UNITS_BASE+unit, 4, true);
    var str = new TextDecoder().decode( new Uint8Array(arrayBuffer) );
    str = str.trim();
    return(str);    
  }
  async setPMC1PhysicalUnit(unit) {
    var uint8Array = new Uint8Array(4);
    var dataView = new DataView(uint8Array.buffer);

    dataView.setUint16(0, unit);
    dataView.setUint16(2, 0);

    await this.setOperatorLevel("specialist", "16021966");  
    await this.modbus.presetMultipleRegisters(0x1, REG_PMC1, uint8Array.buffer);
    await this.setOperatorLevel("user", "0");
  }
  async getPMC(channel) {
    if (!REG_PMC[channel]) throw new Error("Invalid Channel");

    let o={};
    let arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_PMC[channel], 10, true);
    let dataView = new DataView(arrayBuffer);
    o.unit = dataView.getUint32(0, true);
    o.value = dataView.getFloat32(4, true);
    o.status = dataView.getUint32(8, true);
    o.min = dataView.getFloat32(12, true);
    o.max = dataView.getFloat32(16, true);
    return o;    
  }
  async getSMC(channel) {
    if (!REG_SMC[channel]) throw new Error("Invalid Channel");

    let o={};
    let arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_SMC[channel], 10, true);
    let dataView = new DataView(arrayBuffer);
    o.unit = dataView.getUint32(0, true);
    o.value = dataView.getFloat32(4, true);
    o.status = dataView.getUint32(8, true);
    o.min = dataView.getFloat32(12, true);
    o.max = dataView.getFloat32(16, true);
    return o;    
  }  
  async getTCD() {
    let value = (await this.getPMC(1)).value;
    return value;
  }
  async getTemperature() {
    let value = (await this.getPMC(6)).value;
    return value;
  }
  async getTransmissionCurrent() {
    let value = (await this.getSMC(7)).value;
    return value;
  }
  async getReflectionCurrent() {
    let value = (await this.getSMC(10)).value;
    return value;
  }
  async getTransmission() {
    let value = (await this.getSMC(13)).value;
    return value;
  }
  async getReflection() {
    let value = (await this.getSMC(14)).value;
    return value;
  }  
  async getSensorIdentification() {
    let o = {};

    for (const [NAME, SENSOR_IDENTIFICATION_REG] of Object.entries(SENSOR_IDENTIFICATION)) {
      let arrayBuffer = await this.modbus.readHoldingRegisters(0x1, SENSOR_IDENTIFICATION_REG, 8, true);
      let uint8Array = new Uint8Array(arrayBuffer);
      let string = new TextDecoder("utf-8").decode(uint8Array);
      o[NAME]= string;
    }

    return o;
  }
  async getCalibrationStatusString() {
    var statusString = "";
    var arrayBuffer, dataView,status,unit,value;

    arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP1, 6, true);
    dataView = new DataView(arrayBuffer);        
    status = dataView.getUint32(0, true);
    status = status & 0xFF; //0..7 bits represents the CP1 status codes
    unit = dataView.getUint32(4, true);
    unit = PHYSICAL_UNITS[unit];
    value = dataView.getFloat32(8, true);
    statusString += `CP1 (status: ${CALIBRATION_STATUS[status]}, unit: ${unit}, value: ${value}; `;

    arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP2, 6, true);
    dataView = new DataView(arrayBuffer);    
    status = dataView.getUint32(0, true);
    status = ((status >> 8) & 0xFF); //8..15 bits represents the CP2 status codes
    unit = dataView.getUint32(4, true);
    unit = PHYSICAL_UNITS[unit];
    value = dataView.getFloat32(8, true);
    statusString += `CP2 (status: ${CALIBRATION_STATUS[status]}, unit: ${unit}, value: ${value}`;

    return statusString;
  }
  async getCP1CalibrationStatus() {
    var arrayBuffer, dataView,status,unit,value;

    arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP1, 6, true);
    dataView = new DataView(arrayBuffer);        
    status = dataView.getUint32(0, true);
    status = status & 0xFF; //0..7 bits represents the CP1 status codes
    unit = dataView.getUint32(4, true);
    unit = PHYSICAL_UNITS[unit];
    value = dataView.getFloat32(8, true);

    return status;
  }
  async getCP2CalibrationStatus() {
    var arrayBuffer, dataView,status,unit,value;    

    arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_STATUS_CP2, 6, true);
    dataView = new DataView(arrayBuffer);    
    status = dataView.getUint32(0, true);
    status = ((status >> 8) & 0xFF); //8..15 bits represents the CP2 status codes
    unit = dataView.getUint32(4, true);
    unit = PHYSICAL_UNITS[unit];
    value = dataView.getFloat32(8, true);

    return status;
  }

  async clearCalibration() {
    throw new Error("not implemented");
  }
  async calibrateTo0() {
    /* 
       start the calibration at CP1, giving a value of 0 for auto or oxygen (0 %-vol
       in this case)
     */

    var float32Array = new Float32Array([0]);

    await this.setOperatorLevel("administrator", "18111978");
    await this.modbus.presetMultipleRegisters(0x1, REG_CP1, float32Array.buffer);
    await this.setOperatorLevel("user", "0");
    await sleep(100);
    var status = await this.getCP1CalibrationStatus();
    if (status)
      throw new Error( CALIBRATION_STATUS[status] );    
  }
  async calibrateTo21() {
    /*
      start the calibration at CP2, giving a value of 0 for auto (20.95 %-vol in this
      case)
    */

    var float32Array = new Float32Array([0]);

    await this.setOperatorLevel("administrator", "18111978");
    await this.modbus.presetMultipleRegisters(0x1, REG_CP2, float32Array.buffer);
    await this.setOperatorLevel("user", "0");
    await sleep(100);
    var status = await this.getCP2CalibrationStatus();
    if (status)
      throw new Error( CALIBRATION_STATUS[status] );        
  }
  async getGeneralInformation() {
    var arrayBuffer = await this.modbus.readHoldingRegisters(0x1, REG_GENERAL_INFORMATION, 8, true);
    var uint8Array = new Uint8Array(arrayBuffer);
    var string = new TextDecoder("utf-8").decode(uint8Array);
    return string;
  }
  async RM_visifermdo_clearCalibration(request) {
    try {
      await this.clearCalibration();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor calibration data has successfully been deleted`);
    } catch(e) {
      console.error(`${request.client.username}: Clear calibration failed: ${e}`);
      throw e.message;
    }
    return true;
  }
  async RM_visifermdo_calibrateTo0(request) {
    try {
      await this.calibrateTo0();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor has successfully been calibrated to 0 dissolved oxygen level`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e.message;
    }
    return true;
  }
  async RM_visifermdo_calibrateTo21(request) {
    try {
      await this.calibrateTo21();
      console.log(`${request.client.username}: Dissolved Oxygen Sensor has successfully been calibrated to atmospheric oxygen level`);
    } catch(e) {
      console.error(`${request.client.username}: Calibration failed: ${e.message}`);
      throw e.message;
    }
    return true;
  }  
  logData(logData) {
    logData.append(`${this.name}`, this.value);
    logData.append(`${this.name}_reflection`, this.reflection);
    logData.append(`${this.name}_transmission`, this.transmission);
  }    
  toJSON() {
    return({
      name: this.name,            
      usbProductName: this.usbProductName,
      usbSerialNumber: this.usbSerialNumber,      
      status: this.status,      
      id: this.id,
      serialNumber: this.serialNumber,
      value: this.value,
      tcd: this.tcd,
      temperature: this.temperature,
      reflection: this.reflection,
      transmission: this.transmission
    });
  }  
}

export default MyDevice;